import React from 'react'
import styled, { keyframes } from 'styled-components'

import Icon from '../Icon'
import { COLORS, media } from '../../styles'

const Styled = styled(({ tagName: TagName, ...rest }) => <TagName {...rest} />)`
  position: relative;
`
const fadeIn = keyframes`
  from {
    transform: scale(.25);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`
const fadeOut = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(.25);
    opacity: 0;
  }
`
Styled.floatingButton = styled.button`
  align-items: center;
  border-radius: 2rem;
  bottom: 3rem;
  display: flex;
  flex-flow: row nowrap;
  height: 4rem;
  justify-content: space-between;
  left: 0;
  right: 0;
  margin: 0 auto;
  position: fixed;
  border: 0;
  background-color: ${({ buttonClicked }) =>
    buttonClicked ? COLORS.cobalt : COLORS.kale};
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  visibility: ${({ hideButton }) => (hideButton ? 'hidden' : 'visible')};
  animation: ${({ hideButton }) => (hideButton ? fadeOut : fadeIn)} 0.2s
    ease-in-out;
  transition:
    background-color 0.2s ease-in-out,
    visibility 0.2s ease-in-out;
  width: 15.8rem;
  box-shadow:
    0 0.1rem 0.6rem 0 rgb(0 0 0 / 0.06),
    0 0.2rem 3.2rem 0 rgb(0 0 0 / 0.16);
  z-index: 1;
  ${media.medium`
    display: none;
  `}
`
Styled.floatingButtonIcon = styled(Icon)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.floatingButtonText = styled.span`
  color: ${COLORS.white};
  font-size: 1.3rem;
  padding-left: 0.6rem;
  white-space: nowrap;
`

export default Styled
